import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HelpIcon from '@mui/icons-material/Help';

import HeaderButton from './HeaderButton';
import HeaderMenuButton from './HeaderMenuButton';
import logo from '../assets/ls_logo.png';

export default function Header(props) {
  const [selectedNavButton, setSelectedNavButton] = useState(null);

  const handleNavButtonClick = (id) => setSelectedNavButton(id);
  const handleNavButtonClose = () => setSelectedNavButton(null);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      height='67px'
      sx={{ backgroundColor: 'primary.red'}}
    >
      <img
        src={logo}
        style={{ height: '55px', marginLeft: '50px' }}
        alt="ls-logo"
      />
      <Stack
        direction="row"
        sx={{ alignItems: "baseline" }}
      >
        <Box>
          <Link
            to={{ pathname: "https://drive.google.com/file/d/1Gx0FggtC7nd1JxEjz2H8T_Eua5D1LUfj/view" }}
            target='_blank'
            style={{ color: '#FFFFFF' }}
          >
            <HelpIcon/>
          </Link>
        </Box>
        <HeaderButton
          icon={<AccountCircleIcon className='header-icon'/>}
          id='user'
          selectedNavButton={selectedNavButton}
          menuHeading={props.username}
          menuItems={[
            <HeaderMenuButton
              label='LOGOUT'
              to='/logout'
              history={props.history} />
          ]}
          handleNavButtonClick={handleNavButtonClick}
          handleNavButtonClose={handleNavButtonClose}
        />
      </Stack>  
    </Stack>
  )
}
